"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VideoFillXSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16" }, props),
        React.createElement("path", { d: "M13.593,5.09 C13.343,4.957 13.04,4.972 12.802,5.129 L11,6.334 L11,5 C11,4.448 10.551,4 10,4 L4,4 C3.449,4 3,4.448 3,5 L3,11 C3,11.552 3.449,12 4,12 L10,12 C10.551,12 11,11.552 11,11 L11,9.665 L12.802,10.87 C12.932,10.956 13.081,11 13.23,11 C13.355,11 13.479,10.97 13.593,10.909 C13.844,10.774 14,10.514 14,10.229 L14,5.772 C14,5.486 13.844,5.225 13.593,5.09", fillRule: "evenodd" })));
};
VideoFillXSmall.displayName = 'VideoFillXSmall';
exports.default = VideoFillXSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VideoFillXSmall.js.map